/**
 * Authors: mariushirjanu
 * Created: 06/05/2021
 */
import { Injectable } from '@angular/core';

import { HttpDataService } from '../../../shared/http/http-data.service';
import { ISimpleTicket } from '../../../shared/ticket/ticket-data.service';

export interface IWebshopSupplierData {
  regionalHub:false;
  hybridFulfilmentModel:false;
  customerPreferredSupplier:false;
  multipleCountrySuppliers:boolean;
  numActiveCountries:number;
  webshopSetupTicket:ISimpleTicket;
}

@Injectable()
export class WebshopSupplierDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    //empty
  }

  public getWebshopSupplierData(webshopId:number):Promise<IWebshopSupplierData> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/suppliersettings`,
      {},
      undefined,
      'Error loading supplier settings'
    );
  }

  public saveWebshopSupplierData(webshopId:number, data:IWebshopSupplierData):Promise<IWebshopSupplierData> {
    return this.httpDataService.doPUT(
      `rest/webshops/${webshopId}/suppliersettings`,
      undefined,
      data,
      'Saving webshop supplier settings',
      'Error saving supplier settings'
    );
  }
}